/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./operation-result-types";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMessages = /* GraphQL */ `query GetMessages($msg_type: String, $pk: String!) {
  getMessages(msg_type: $msg_type, pk: $pk) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessagesQueryVariables,
  APITypes.GetMessagesQuery
>;
export const getMessagesBySessionId = /* GraphQL */ `query GetMessagesBySessionId($sessionId: String!) {
  getMessagesBySessionId(sessionId: $sessionId) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessagesBySessionIdQueryVariables,
  APITypes.GetMessagesBySessionIdQuery
>;
export const getTemplateMessages = /* GraphQL */ `query GetTemplateMessages($pk: String!, $vault_user_form_id: String!) {
  getTemplateMessages(pk: $pk, vault_user_form_id: $vault_user_form_id) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateMessagesQueryVariables,
  APITypes.GetTemplateMessagesQuery
>;
export const getUserConnections = /* GraphQL */ `query GetUserConnections($from_user_id: String, $impersonate_user_id: String) {
  getUserConnections(
    from_user_id: $from_user_id
    impersonate_user_id: $impersonate_user_id
  ) {
    connection_status
    created_at
    from_user_id
    last_reminder_sent
    relationship_id
    relationship_name
    reminder_count
    to_user_id
    updated_at
    user_birthdate
    user_city
    user_country
    user_email
    user_first_middle_name
    user_first_name
    user_has_passed_away
    user_has_passed_away_date
    user_id
    user_last_name
    user_middle_name
    user_nickname
    user_phone_number
    user_profile_image_url
    user_state
    user_street
    user_type
    user_your_self
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserConnectionsQueryVariables,
  APITypes.GetUserConnectionsQuery
>;
export const getUserSessions = /* GraphQL */ `query GetUserSessions($pk: String!) {
  getUserSessions(pk: $pk) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserSessionsQueryVariables,
  APITypes.GetUserSessionsQuery
>;
export const getUserSuggestions = /* GraphQL */ `query GetUserSuggestions($user_id: String!) {
  getUserSuggestions(user_id: $user_id) {
    loginuserid
    mutual_connections_count
    myMutualConnectionList {
      first_name
      last_name
      mutual_user_id
      search_user_id
      uid
      __typename
    }
    user_first_name
    user_id
    user_last_name
    user_profile_image_url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserSuggestionsQueryVariables,
  APITypes.GetUserSuggestionsQuery
>;
export const search = /* GraphQL */ `query Search($search_type: String, $search_val: String) {
  search(search_type: $search_type, search_val: $search_val) {
    connection_status
    relationship_id
    relationship_name
    user_city
    user_country
    user_first_middle_name
    user_first_name
    user_has_passed_away
    user_has_passed_away_date
    user_id
    user_last_name
    user_middle_name
    user_nickname
    user_profile_image_url
    user_search_type
    user_state
    user_type
    user_your_self
    __typename
  }
}
` as GeneratedQuery<APITypes.SearchQueryVariables, APITypes.SearchQuery>;
